<template>
  <div class="flex flex-col md:flex-row  min-h-screen">
    <portal-target name="destination"/>
    <portal-target name="facebookModal"/>
    <portal-target name="dropdown" slim/>

    <MobileMenu :user="$page.props.user"/>
    <AppsMenu
      v-if="$page.props.hasAppMenu"
      :user="$page.props.user"
      :open="menuOpen"
      @toggle="toggleMenu"
    />
    <Filters :class="{'ml-17': $page.props.hasAppMenu}" :open="menuOpen" @toggle="toggleMenu"/>

    <main class="order-0 flex-1 z-10 shadow-page sm:rounded-l-xl w-full">
      <div class="overflow-hidden min-h-full">
        <slot />
      </div>
    </main>
  </div>
</template>

<script>

import MobileMenu from "@/components/shared/app-menu/MobileMenu"
import AppsMenu from "@/components/shared/app-menu/AppsMenu"
import Filters from "@/components/shared/Filters"

export default {
  components: {Filters, AppsMenu, MobileMenu},

  data() {
    return {
      menuOpen: true,
    }
  },

  methods: {
    toggleMenu(state) {
      this.menuOpen = state
    }
  },
}
</script>

<style>
.page-enter-active,
.page-leave-active {
  @apply transition duration-150 ease-in-out;
}

.page-enter,
.page-leave-active {
  opacity: 0;
}
</style>
